import { withProductDetailProvider } from '@/features/products/contexts/hoc-context'
import { getVND } from '@/utils/helpers'
import { Box, Typography } from '@mui/material'
import Image from 'next/image'
import Link from 'next/link'
import { useMemo } from 'react'
type Props = {
  product?: Product
  configOptiuons?: {
    attributes: {
      code: string
      label: string
      uid: string
    }[]
  }
}

function ProductSmallItemCore({ product, configOptiuons }: Props) {
  // tìm variant dựa trên configOptiuons
  const productSelected = useMemo(() => {
    if (!configOptiuons || !product) return product?.variants?.[0]
    let selectedProduct = product?.variants?.find((variant) => {
      return configOptiuons.attributes.every((attr) => {
        const option = variant?.attributes?.find((a) => a?.code === attr.code)
        return option?.uid === attr.uid
      })
    })

    return selectedProduct || product?.variants?.[0]
  }, [configOptiuons, product])

  const mainImage = productSelected?.product?.image?.url || product?.image?.url || ''
  const link =
    '/products/' +
    (product?.url_key || '/') +
    '?' +
    configOptiuons?.attributes.map((attr) => `${attr.code}=${attr.uid}`).join('&')
  const priceOld = product?.price_range.maximum_price?.final_price?.value || 0
  const priceNew = product?.price_range.minimum_price?.final_price?.value || 0
  const name = product?.name
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        padding: { xs: 1, md: 2 },
        alignItems: 'center',
        ':not(:last-child)': {
          borderBottom: '1px solid #E0E0E0',
        },
      }}
    >
      <Box
        sx={{
          width: '5rem',
          height: '5rem',
          flexShrink: 0,
          borderRadius: '0.4rem',
          overflow: 'hidden',
          backgroundColor: '#F5F5F5',
        }}
      >
        <Image src={mainImage} alt="Product" width={80} height={80} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="body2"
          fontWeight={600}
          sx={{
            fontSize: { xs: '1rem', md: '1.125rem' },
            mb: 0.5,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          <Link href={link}>{name}</Link>
        </Typography>
        {/* <ListOptions defaultSelectedOptions={{ attribute_code: product }} /> */}
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
          <Typography
            fontWeight={700}
            sx={{
              fontSize: '1rem',
              color: 'primary.main',
            }}
          >
            {' '}
            {getVND(priceNew, 'Đ')}
          </Typography>
          <Typography
            sx={{
              fontSize: '0.8rem',
              color: 'inherit',
            }}
          >
            /áo
          </Typography>
          {priceNew < priceOld && (
            <Typography
              sx={{
                fontSize: '0.875rem',
                color: '#9B9A99',
                textDecoration: 'line-through',
              }}
            >
              {getVND(priceOld, 'Đ')}/áo
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}
export const ProductSmallItem = withProductDetailProvider(ProductSmallItemCore)
